import { SearchWithExtras } from 'generated/api'
import React from 'react'
import { determineSearchType, SearchType } from './helpers'
import styled from '@emotion/styled'
import { COLORS } from 'parameters/index'
import Link from 'next/link'
import { UrlObject } from 'url'

interface SearchNoticeProps {
	search?: SearchWithExtras
}

export const SearchNotice = ({ search }: SearchNoticeProps): JSX.Element => {
	if (!search) return <></>
	const searchType = determineSearchType(search)
	const newSearchUrl: UrlObject = { pathname: '/explore/loans', query: { productType: 'loan' } }
	switch (searchType) {
		case SearchType.noOffers:
			return (
				<Notice>
					No offers were returned for this search. <Link href={newSearchUrl}>Expand your search.</Link>
				</Notice>
			)
		case SearchType.expired:
			return (
				<Notice>
					Unfortunately, this search expired. <Link href={newSearchUrl}>Search Again.</Link>
				</Notice>
			)
		case SearchType.error:
			return <Notice>There was an error fetching your search.</Notice>
		case SearchType.inProgress:
			return <Notice>Continue where you left off.</Notice>
		default:
			return <></>
	}
}
const Notice = styled.span`
	font-size: 14px;
	font-weight: 600;
	padding: 8px;
	line-height: 22px;

	a {
		color: ${COLORS.MALACHITE_GREEN};
		font-size: 14px;
		font-weight: 600;
	}
`
